export var getLegacyMinicart = function getLegacyMinicart() {
  var _window, _window$cotd;

  return true && (_window = window) !== null && _window !== void 0 && (_window$cotd = _window.cotd) !== null && _window$cotd !== void 0 && _window$cotd.miniCart ? window.cotd.miniCart : undefined;
};